import { loginApi, userApi } from "@/core/apis";
import JwtService from "@/core/services/jwt.service";
import router from "@/router";
import { xLocalStorage } from "@/core/services/xLocalStorage.service";

import {
  // actions
  PURGE_VEHICLE_TREE_DATA
} from "@/core/services/store/entities/vehicleTreeFlat.module";

import {
  // actions
  PURGE_ARBAEEN_TREE_DATA
} from "@/core/services/store/entities/arbaeenTree.module";

import {
  getAllPermissions,
  hasPermissions
} from "@/assets/js/components/XPermissionManager";

// getter types
export const TIMER = "timer";

// action types
export const LOGIN = "login";
export const LOGIN_SSO = "loginSSO";
export const LOGOUT = "logout";
export const GENERATE_AUTHENTICATED_USER = "generateAuthenticatedUser";
export const UPDATE_TIMER = "updateTimer";

// mutation types
const PURGE_AUTH = "purgeAuth";
const SET_AUTH = "setUser";
const SET_AUTHENTICATED_USER = "setAuthenticatedUser";
const SET_TIMER = "setTimer";

const USER_UI_SETTINGS = "userUISettings";

const state = {
  user: {},
  remindTimer: 30
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  [TIMER](state) {
    return state.remindTimer;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      context.commit(PURGE_AUTH);

      loginApi.doLogin(credentials).then(loginResponse => {
        if (loginResponse.success) {
          context.commit(SET_AUTH, loginResponse.token);
        }

        resolve(loginResponse.success);
      });
    });
  },
  [LOGIN_SSO](context, request) {
    return new Promise(resolve => {
      context.commit(PURGE_AUTH);

      loginApi.doLoginSSO(request).then(loginResponse => {
        if (loginResponse.success) {
          context.commit(SET_AUTH, loginResponse.token);
        }

        resolve(loginResponse.success);
      });
    });
  },
  [LOGOUT](context) {
    return new Promise(resolve => {
      loginApi.doLogout().then(() => {
        context.commit(PURGE_AUTH);
        context.dispatch(PURGE_VEHICLE_TREE_DATA);
        context.dispatch(PURGE_ARBAEEN_TREE_DATA);
        router.push({ name: "auth_login" });
        resolve();
      });
    });
  },
  [GENERATE_AUTHENTICATED_USER](context) {
    return new Promise(resolve => {
      userApi.getCurrentUser().then(currentUser => {
        context.commit(SET_AUTHENTICATED_USER, currentUser);
        resolve();
      });
    });
  },
  [UPDATE_TIMER](context, payload) {
    context.commit(SET_TIMER, payload);
  }
};

const mutations = {
  [SET_AUTH](state, tokens) {
    state.isAuthenticated = true;
    state.errors = {};
    JwtService.saveToken(tokens);
  },
  [PURGE_AUTH](state) {
    xLocalStorage.remove(USER_UI_SETTINGS);
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyAllTokens();
  },
  [SET_AUTHENTICATED_USER](state, user) {
    xLocalStorage.remove(USER_UI_SETTINGS);

    const userUISettings = {
      defaultRouteName: hasPermissions(
        [getAllPermissions().DashBoard],
        user.permittedUsecases
      )
        ? "pages_dashboard_management"
        : "pages_monitoring_instant"
    };

    xLocalStorage.set(USER_UI_SETTINGS, JSON.stringify(userUISettings));

    state.user = user;
    state.user.isAuthenticated = !!JwtService.getAccessToken();
    state.user.defaultRouteName = userUISettings.defaultRouteName;
  },
  [SET_TIMER](state, value) {
    state.remindTimer = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
